export default __webpack_public_path__ + "images/43475fc3138f77dbb790b6d1c4dc306d-dealernet.svg";